import { CdkMenu } from '@angular/cdk/menu';
import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { AuthService } from '@core/security/services/auth.service';
import { MapConfigState } from '../state/map-config.state';
import { MapContextMenuItemConfiguration } from '@map/types';
import { MapContextMenuItemComponent } from './widget/map-context-menu-item.component';

@Component({
    selector: 'dash-gis-map-context-menu',
    templateUrl: './map-context-menu.component.html',
    styleUrls: [ './map-context-menu.component.scss' ],
    imports: [ CdkMenu, MapContextMenuItemComponent, AsyncPipe ]
})
export class MapContextMenuComponent implements OnInit, OnDestroy {
    visibleMenuItems$: Observable<MapContextMenuItemConfiguration[]>;
    private store = inject(Store);
    private mapConfigLoaded$: Observable<boolean> = this.store.select(MapConfigState.loaded);
    private menuItems$: Observable<MapContextMenuItemConfiguration[]> = inject(Store).select(
        MapConfigState.contextMenuItems
    );

    private dispose$ = new Subject<void>();

    constructor(private authService: AuthService) {}

    ngOnInit(): void {
        this.visibleMenuItems$ = this.mapConfigLoaded$.pipe(
            distinctUntilChanged(),
            filter((loaded) => loaded),
            switchMap(() => this.menuItems$),
            map((widgets) => widgets.filter((w) => this.authService.isAuthorized(w.roles || [])))
        );
    }

    ngOnDestroy() {
        this.dispose$.next();
    }
}
